export default function truncateText(text, maxLength) {
    // Check if text length is greater than maxLength
    if (text.length > maxLength) {
      // Truncate and add ellipsis
      return text.slice(0, maxLength - 3) + '...';
    }
    // Return original text if no truncation is needed
    return text;
}